import { RemittanceReturnProtocolResponse } from '@/core/domain/financial/Boletos/Boletos.types';
import {
  Alert,
  Col,
  Collapse,
  Descriptions,
  Modal,
  ModalProps,
  Row,
  Tooltip,
  Typography,
} from 'antd';

import { InfoCircleOutlined } from '@ant-design/icons';
import DescriptionsItem from 'antd/lib/descriptions/Item';
import UnreconciledTitlesCollapsePanelData from './UnreconciledTitlesCollapsePanelData';

interface Props extends Omit<ModalProps, 'onCancel'> {
  data?: RemittanceReturnProtocolResponse;
  onCancel: VoidFunction;
}

export default function ConsultFileResponseModal({
  data,
  onCancel,
  ...props
}: Props) {
  return (
    <Modal
      {...props}
      width={600}
      title="Retorno da consulta do protocolo"
      onCancel={onCancel}
      footer={[]}
    >
      {!!data ? (
        <Row gutter={[12, 12]}>
          <Col span={24}>
            {data.situation === 'PROCESSANDO' && (
              <Alert
                type="warning"
                description="Quando a situação for igual PROCESSANDO, feche o modal e consulte novamente com o protocolo, até que a situação seja igual a PROCESSADA."
                style={{ marginBottom: 12 }}
              />
            )}

            <Descriptions column={1}>
              <Descriptions.Item
                label="Situação"
                contentStyle={{ fontWeight: 'bold' }}
              >
                {data.situation}
              </Descriptions.Item>

              <Descriptions.Item
                label="Mensagem"
                contentStyle={{ fontWeight: 'bold' }}
              >
                {data?.message ?? '-'}
              </Descriptions.Item>

              <Descriptions.Item
                label="Processados"
                contentStyle={{ fontWeight: 'bold' }}
              >
                {data?.processed ?? '-'}
              </Descriptions.Item>
            </Descriptions>
          </Col>

          <Col span={24}>
            <Collapse accordion>
              {!!data.titles?.length && (
                <Collapse.Panel
                  header={<strong>Titulos</strong>}
                  key="1"
                  extra={
                    <Tooltip title="São todos os Ids de integração que foram conciliados com aquele arquivo de retorno.">
                      <InfoCircleOutlined />
                    </Tooltip>
                  }
                >
                  <Descriptions column={1}>
                    {data.titles?.map((title) => (
                      <DescriptionsItem
                        label="Id integração"
                        contentStyle={{ fontWeight: 'bold' }}
                      >
                        {title.integrationId}
                      </DescriptionsItem>
                    ))}
                  </Descriptions>
                </Collapse.Panel>
              )}

              {!!data.unreconciledTitles?.length && (
                <Collapse.Panel
                  header={<strong>Titulos não conciliados</strong>}
                  key="2"
                  extra={
                    <Tooltip title="Retorna os dados dos boletos que estão presentes no arquivo de retorno, mas que não estão em nossa base (isso acontece quando o cedente emite o boleto direto pelo banco).">
                      <InfoCircleOutlined />
                    </Tooltip>
                  }
                >
                  <UnreconciledTitlesCollapsePanelData
                    unreconciledTitles={data.unreconciledTitles}
                  />
                </Collapse.Panel>
              )}
            </Collapse>
          </Col>
        </Row>
      ) : (
        <Typography.Title>Não há dados</Typography.Title>
      )}
    </Modal>
  );
}
